import React from 'react';

import MenuLinks from '../../components/MenuLinks';
import SocialIconComponent from '../../components/SocialIconComponent';
import { zivaLogo_Image } from '../../constants/imageConstants';

function Footer() {
  return (
    <div className="shadow shadow-slate-600">
      <div className="grid lg:grid-cols-12 shadow-t shadow-subMain px-5 pb-20 lg:pb-5 items-center grid-cols-2 sm:grid-cols-4 md:grid-cols-7 xl:grid-cols-12 gap-5 sm:gap-9 lg:gap-11 xl:gap-7 lg:py-10 justify-between">
        <div className="lg:col-span-4 flex flex-col gap-3">
          <div className="w-80">
          <img src={zivaLogo_Image} loading="lazy" alt={"Logo"} className="h-16 object-cover" />
          </div>
          <p className="lg:w-80 md:w-64 xs:w-[80vw] w-[80vw]">
            Ziva Interiors and the Ziva Interiors logo are registered
            trademarks of Ziva Interiors, Pvt Ltd. All other trademarks are
            the property of their respective owners.
          </p>
          <a href="https://storyset.com" className="hover:text-main transitions underline w-80" target="_blank" rel="noreferrer">Used illustrations by Storyset</a>
          <a href="https://www.flaticon.com/free-icons/dream" title="dream icons" className="hover:text-main transitions underline w-80" target="_blank" rel="noreferrer">Dream icons created by Freepik - Flaticon</a>
        </div>
        <div className="lg:col-span-5 col-span-6 gap-6 flex flex-col  md:items-center items-start">
          <div>
            <h2 className="text-2xl ">Links</h2>
            <MenuLinks isBlack={false} />
          </div>
        </div>
        <div className="col-span-3 flex flex-col gap-4">
          <p className="text-2xl">Contact Us</p>
          <div className="flex flex-col">
            <span className="font-ivy_mode font-bold">(+91) 9989785556 / (+91) 9704456746</span>
            <span className="text-main font-bold">contactus@zivainteriors.com</span>
            <span>Ziva Interiors | Masab Tank, Hyderabad India 500088</span>
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-between items-center p-4">
        <div className="col-span-6 flex flex-row gap-2">
          <SocialIconComponent />
        </div>
        <div className="col-span-5">
          <p>© 2023 Ziva Interiors.</p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
